import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { NavigateOptions, To } from 'react-router-dom';

import { navigateReplace, navigateWithBack } from '@/lib/navigation';

export function useMobileNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  const go = useCallback(
    (to: To, options: NavigateOptions = {}) => {
      navigateReplace(navigate, to, options);
    },
    [navigate]
  );

  const goWithBack = useCallback(
    (to: To, options: Omit<NavigateOptions, 'state'> & { state?: Record<string, unknown> } = {}) => {
      navigateWithBack(navigate, location, to, options);
    },
    [location, navigate]
  );

  return {
    go,
    goWithBack,
  };
}
